import React, { useState, useEffect, useCallback } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Panel from '../../components/common/Panel';
import Wall from '../../components/common/Wall';
import Spinner from '../../components/common/Spinner';
import Stats from '../../components/blocks/Stats';
import PageLayout from '../../components/common/PageLayout';
import { getStats, getStatsSupplierRetailers } from '../../store/actions/supplierStats';
import DateRange from '../../components/common/DateRange/DateRange';
import DropDownFilter from '../../components/filters/DropDownFilter';
import { getValidDateFromLocalStorage } from '../../utils/dateHelper';
import { isEmpty } from 'lodash';
import { reportBusinessActionToMixpanel } from '../../utils/reportBusinessActionToMixpanel';
import { endOfDay, startOfDay } from 'date-fns';

function StatsPageContainer(props) {
  const { getRetailers, getStats } = props;

  const [retailerId, setRetailerId] = useState(props.retailerId || 0);
  const [dateRange, setDateRange] = useState({
    startDate: getValidDateFromLocalStorage('statsStartDate', startOfDay(new Date())),
    endDate: getValidDateFromLocalStorage('statsEndDate', endOfDay(new Date())),
  });

  const mixpanel = useMixpanel();

  const reportBi = useCallback(
    (event, meta) => {
      reportBusinessActionToMixpanel(mixpanel, event, meta);
    },
    [mixpanel],
  );

  useEffect(() => {
    reportBi('enter-ng-stats-2-page');
  }, [reportBi]);

  useEffect(() => {
    getRetailers();
  }, [getRetailers]);

  useEffect(() => {
    getStats(dateRange.startDate, dateRange.endDate, retailerId);
  }, [getStats, dateRange, retailerId]);

  const retailers = props.retailers.map((retailer) => ({
    value: retailer.id,
    label: retailer.name,
  }));

  retailers.unshift({
    value: 0,
    label: 'All Retailers',
  });
  const pageHero = (
    <Panel>
      <Wall />
      <DateRange
        onChange={(startDate, endDate) => {
          setDateRange({ startDate, endDate });
        }}
        startDateStorageKey="statsStartDate"
        endDateStorageKey="statsEndDate"
        limitToMonth={false}
      />
      <Wall />
      {props.retailers && (
        <>
          <DropDownFilter currentIndex={retailerId} values={retailers} onChange={setRetailerId} />
          <Wall />
        </>
      )}
    </Panel>
  );

  return (
    <PageLayout top={pageHero}>
      {isEmpty(props.data) ? (
        <Spinner />
      ) : (
        <Stats data={props.data} startDate={dateRange.startDate} endDate={dateRange.endDate} />
      )}
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { data, isLoading, retailers } = state.supplierStats;

  return {
    data,
    isLoading,
    retailers,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStats: (startDate, endDate, retailerId) => dispatch(getStats(startDate, endDate, retailerId)),
  getRetailers: () => dispatch(getStatsSupplierRetailers()),
});

StatsPageContainer.propTypes = {
  getStats: PropTypes.func.isRequired,
  filter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default connect(mapStateToProps, mapDispatchToProps)(StatsPageContainer);
